module.exports = __webpack_public_path__ + "img/54.73b9ead4.png";